import React from 'react'
import AdminActionsComponent from '../../Components/adminActionsComponent'
import Aside from '../../Components/aside'
import TopBar from '../../Components/topBar'


const AdminActions = () => {
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <AdminActionsComponent/>
      </div>
    </div>

  )
}

export default AdminActions